var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForgot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 486.434,
    height: 390.544,
    viewBox: "0 0 486.434 390.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_questions_re_1fy7",
    transform: "translate(-41.65)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 30.222,
    cy: 30.222,
    r: 30.222,
    transform: "translate(250.175 329.812)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M684.047,557.013c16.908-5.078,34.882-10.373,48.291-22.444,11.982-10.787,20.071-27.258,15.107-43.435-4.954-16.144-19.791-26.908-35.111-32.262-8.689-3.037-17.779-4.721-26.865-6.045-9.878-1.439-19.8-2.617-29.716-3.752q-60.231-6.889-120.916-8.417c-19.963-.5-39.922-.491-59.887-.2-17.83.259-36.609.252-53.15-7.326-12.863-5.893-24.537-16.615-28.122-30.7-4.137-16.264,3.494-32.826,14.441-44.6a116.914,116.914,0,0,1,19.471-16.239c7.547-5.213,15.358-10.056,23.337-14.578a324.977,324.977,0,0,1,49.121-22.646c8.374-3.045,16.872-5.672,25.444-8.1a217.71,217.71,0,0,0,21.494-6.884c13.523-5.39,26.386-14.52,29.824-29.487,3.259-14.185-2.236-29.585-11.869-40.123-11.144-12.192-27.948-17.536-44.058-18.4-18.086-.971-35.755,3.556-52.755,9.3C450,216.8,432.257,223.844,413.743,228.807a365.918,365.918,0,0,1-55.973,10.4c-9.252.985-18.784,2.1-28.091,1.343-7.8-.632-15.56-2.926-21.309-8.462-4.929-4.747-7.865-11.27-6.856-18.154.183-1.25,2.083-.719,1.9.524-1.229,8.38,4.468,16.1,11.487,20.058,8.113,4.572,17.985,4.578,27.017,4.055a353.361,353.361,0,0,0,58.154-8.407c18.785-4.291,36.9-10.424,54.993-16.976,17.184-6.223,34.753-12.3,53.112-13.644,15.93-1.169,32.687,1.151,46.564,9.476a51.512,51.512,0,0,1,24.023,33.519c2.793,13.682-1.075,27.453-11.432,37-10.723,9.885-25.426,14.112-39.128,18a358.478,358.478,0,0,0-50.847,18.2,319.2,319.2,0,0,0-47.829,26.89c-14.616,9.988-29.04,22.555-33.662,40.373a37.193,37.193,0,0,0,1.847,24.943,45.579,45.579,0,0,0,14.626,17.357C427,436.1,445.486,438.317,463.2,438.537c19.895.248,39.79-.424,59.691-.1q60.837,1,121.425,7.406,15.182,1.607,30.325,3.552a274.184,274.184,0,0,1,27.12,4.4c15.875,3.685,31.322,10.769,41.188,24.229a38.313,38.313,0,0,1,3.263,41.894c-7.577,14.908-21.768,24.39-36.84,30.619a261.386,261.386,0,0,1-24.8,8.374.986.986,0,0,1-.524-1.9Z",
    transform: "translate(-223.103 -168.455)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(63.917 29.893)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(173.307 59.787)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(265.943)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(323.759 67.014)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(245.576 144.539)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(146.37 181.988)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(251.489 240.461)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(364.493 273.31)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 15.768,
    cy: 15.768,
    r: 15.768,
    transform: "translate(496.549 266.083)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M558.924,220.372a87.457,87.457,0,0,0-86.577,85.946c-.006.436-.009,3.5-.009,7.512A22.172,22.172,0,0,0,494.506,336h0a22.185,22.185,0,0,0,22.181-22.2c0-2.733,0-4.621,0-4.737a42.048,42.048,0,1,1,64.728,35.4l.008.009s-31.554,20.314-41.174,48.181l.008,0a61.761,61.761,0,0,0-2.545,17.586c0,2.448.144,23.863.422,41.245a22.854,22.854,0,0,0,22.857,22.484h0a22.861,22.861,0,0,0,22.859-23c-.1-15.918-.149-34.454-.149-35.8,0-17.111,16.507-34.16,30.067-45.278a91.193,91.193,0,0,0,31.363-49.931,57,57,0,0,0,1.642-12.374,87.216,87.216,0,0,0-87.847-87.214Z",
    transform: "translate(-281.764 -175.694)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 19.71,
    cy: 19.71,
    r: 19.71,
    transform: "translate(390.152 139.938)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M566.806,565.909h-8.054l-3.832-31.068h11.888Z",
    transform: "translate(-193.366 -183.453)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M546.89,578.626h15.534v9.781H537.109a9.781,9.781,0,0,1,9.781-9.781Z",
    transform: "translate(-187.257 -198.471)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M661.806,565.909h-8.054l-3.832-31.068h11.888Z",
    transform: "translate(-225.952 -183.453)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M641.89,578.626h15.534v9.781H632.109A9.781,9.781,0,0,1,641.89,578.626Z",
    transform: "translate(-219.842 -198.471)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 16.136,
    cy: 16.136,
    r: 16.136,
    transform: "translate(390.73 147.199)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M786.07,480.734l7.22-16.589a20.618,20.618,0,0,0-4.566-23.389A20.951,20.951,0,0,0,786.707,439a20.324,20.324,0,0,0-12.476-4.316,21.14,21.14,0,0,0-8.8,1.958c-.237.105-.467.217-.7.328-.453.217-.9.453-1.334.7a20.813,20.813,0,0,0-10.315,15.689l-3.187,26.7c-.8,2.1-29.394,77.782-19.394,135.565a2.935,2.935,0,0,0,2.51,2.411l10.138,1.38a2.954,2.954,0,0,0,3.291-2.319l17.01-81.08a2.3,2.3,0,0,1,4.468-.151l24.033,85.265a2.938,2.938,0,0,0,2.832,2.155,3.349,3.349,0,0,0,.572-.053l12.384-2.385a2.937,2.937,0,0,0,2.385-3.16C808.3,597.39,798.625,495.733,786.07,480.734Z",
    transform: "translate(-369.586 -249.205)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M706.079,418.331a6.606,6.606,0,0,0,6.96,7.36l9.02,21.676,6.823-10.114L719.27,418.22a6.642,6.642,0,0,0-13.192.111Z",
    transform: "translate(-361.922 -241.566)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M796.288,524.117a6.607,6.607,0,0,0,5.536-8.484L820.8,501.811l-11.425-4.279-16.27,13.782a6.642,6.642,0,0,0,3.182,12.8Z",
    transform: "translate(-390.316 -270.761)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M740.925,470.727a11.208,11.208,0,0,1-2.167-.214,10.712,10.712,0,0,1-7.85-6.318l-12.637-15.409A2.957,2.957,0,0,1,719,444.4l8.991-5.565a2.957,2.957,0,0,1,4.083.979l8.906,14.673,17.056-12.605a6.387,6.387,0,0,1,7.431,10.224l-17.024,15.529A10.678,10.678,0,0,1,740.925,470.727Z",
    transform: "translate(-365.89 -250.475)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M817.535,496.417h-.069a2.961,2.961,0,0,1-2.175-1.032L807.3,486.06a2.957,2.957,0,0,1,.6-4.384L822.87,471.7,809.31,455.4a6.387,6.387,0,0,1,9.781-8l16.48,16.1a10.857,10.857,0,0,1-2.415,17.7l-13.469,14.292A2.961,2.961,0,0,1,817.535,496.417Z",
    transform: "translate(-396.412 -252.991)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M790.647,457.413a3.041,3.041,0,0,1-.383-.024,2.931,2.931,0,0,1-2.438-2.016l-6.007-18.415a2.026,2.026,0,0,1,1.047-2.447l.195-.092c.177-.084.352-.167.53-.247a21.4,21.4,0,0,1,8.937-1.986,20.582,20.582,0,0,1,11.275,3.388,2.057,2.057,0,0,1,.592,2.822l-11.268,17.652a2.927,2.927,0,0,1-2.481,1.367Z",
    transform: "translate(-387.883 -248.347)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 6.45,
    cy: 6.45,
    r: 6.45,
    transform: "translate(418.952 137.949)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M787.193,361.365h0a17.082,17.082,0,0,0-17.082,17.082v7.227H779l4.251-7.227,1.275,7.227H811.5l-7.227-7.227a17.082,17.082,0,0,0-17.082-17.082Z",
    transform: "translate(-383.901 -224.056)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M834.809,361.817a9.954,9.954,0,0,1,10.828-6.83c4.11.687,7.36,3.991,9.3,7.681s2.83,7.82,4.132,11.779,3.148,7.939,6.434,10.5,8.329,3.258,11.556.622a13.218,13.218,0,0,1-24.622,4.718c-1.7-3.03-2.142-6.581-2.648-10.02s-1.161-7-3.194-9.816-5.839-4.66-9.069-3.376Z",
    transform: "translate(-406.093 -221.836)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M500.6,344.362h0a22.172,22.172,0,0,1-22.17-22.168c0-4.013,0-7.079.009-7.515a86.4,86.4,0,0,1,10.091-39.36,86.6,86.6,0,0,0-16.661,49.872c-.006.436-.009,3.5-.009,7.512a22.172,22.172,0,0,0,22.168,22.171h0a22.189,22.189,0,0,0,21.345-16.156A22.09,22.09,0,0,1,500.6,344.362Z",
    transform: "translate(-281.601 -194.541)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M588.659,285.965a42.05,42.05,0,0,1,36.568,58.744A42.046,42.046,0,1,0,554.648,300.7,41.963,41.963,0,0,1,588.659,285.965Z",
    transform: "translate(-309.996 -194.571)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M601.214,543.6h0a22.856,22.856,0,0,1-22.857-22.489c-.278-17.377-.422-38.792-.422-41.24a61.764,61.764,0,0,1,2.545-17.586l-.008,0a62.435,62.435,0,0,1,3.61-8.344,72.3,72.3,0,0,0-10.18,18.856l.008,0a61.755,61.755,0,0,0-2.545,17.586c0,2.448.144,23.863.422,41.245a22.855,22.855,0,0,0,22.857,22.484h0a22.864,22.864,0,0,0,21.944-16.453A22.772,22.772,0,0,1,601.214,543.6Z",
    transform: "translate(-315.73 -255.808)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M126.54,566.365h8.054l3.832-31.068H126.538Z",
    transform: "translate(-46.429 -183.609)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M0,0H25.315V9.781H9.781A9.781,9.781,0,0,1,0,0Z",
    transform: "translate(103.697 390.235) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M82.54,566.365h8.054L94.426,535.3H82.538Z",
    transform: "translate(-31.337 -183.609)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M0,0H25.315V9.781H9.781A9.781,9.781,0,0,1,0,0Z",
    transform: "translate(74.789 390.235) rotate(179.997)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M265.291,664.137l-7.868-.414a3.071,3.071,0,0,1-2.9-3.263l9.4-104.112,43.3,11.685L311.4,566.9l-13.047,92.166a3.086,3.086,0,0,1-2.863,2.592l-8.481.4a3.071,3.071,0,0,1-3.24-3.151l1.537-55.317a1.024,1.024,0,0,0-2.026-.237l-14.82,58.349a3.052,3.052,0,0,1-3,2.448C265.4,664.141,265.347,664.14,265.291,664.137Z",
    transform: "translate(-207.049 -290.936)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 16.136,
    cy: 16.136,
    r: 16.136,
    transform: "translate(65.42 147.954)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M265.5,460.94l1.774,38.282.641,13.927a3.05,3.05,0,0,0,2.02,2.743l41.611,15.074a2.944,2.944,0,0,0,1.051.184A3.051,3.051,0,0,0,315.659,528l-1.706-68.832a24.263,24.263,0,0,0-20.2-23.44c-.4-.061-.812-.123-1.221-.177a23.816,23.816,0,0,0-19.161,6.2A24.464,24.464,0,0,0,265.5,460.94Z",
    transform: "translate(-210.807 -249.441)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M356.646,553.833a6.612,6.612,0,0,1-3.527-10l-14.111-18.764,12.177-.754,11.533,17.934a6.643,6.643,0,0,1-6.072,11.587Z",
    transform: "translate(-236.031 -279.947)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M338.448,515.612a3.052,3.052,0,0,1-1.67-1.655L315.52,463.306a8.188,8.188,0,0,1,15.1-6.338L351.88,507.62a3.074,3.074,0,0,1-1.643,4.02L340.8,515.6a3.05,3.05,0,0,1-2.35.011Z",
    transform: "translate(-227.755 -255.126)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M298.318,524.822l20.419-39.1a3.2,3.2,0,0,1,4.32-1.356l29.638,15.479a3.205,3.205,0,0,1,1.356,4.32l-20.419,39.1a3.205,3.205,0,0,1-4.32,1.356l-29.638-15.479a3.2,3.2,0,0,1-1.355-4.32Z",
    transform: "translate(-221.95 -266.122)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M303.8,510.637a6.612,6.612,0,0,0-10.195-2.93l-19.564-12.978-.033,12.2,18.583,10.454a6.643,6.643,0,0,0,11.209-6.746Z",
    transform: "translate(-213.735 -269.8)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M269.34,496l-15.989-12.665a11.276,11.276,0,0,1-5.14-17.828l14.518-19.026a6.633,6.633,0,0,1,11.254,6.757L262.5,472.023l16.881,8.007a3.071,3.071,0,0,1,1.28,4.415l-6.814,10.784a3.076,3.076,0,0,1-2.08,1.387l-.051.008A3.085,3.085,0,0,1,269.34,496Z",
    transform: "translate(-204.014 -252.415)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M283.7,401.066a1.4,1.4,0,0,1,1.22-1.852,3.239,3.239,0,0,1,2.284,1.127,9.086,9.086,0,0,0,2.018,1.733,1.736,1.736,0,0,0,2.284-.413,3.177,3.177,0,0,0-.121-2.466,24.249,24.249,0,0,1-1.071-6.419,11.3,11.3,0,0,1,1.616-6.864c1.737-2.447,4.843-3.376,7.782-3.309s5.831.975,8.743,1.548c1.005.2,2.187.3,2.859-.48.715-.828.452-2.169.148-3.287-.789-2.9-1.626-5.9-3.459-8.247a12.416,12.416,0,0,0-7.924-4.461,19.013,19.013,0,0,0-8.845,1,23.715,23.715,0,0,0-11.618,8.093,19.208,19.208,0,0,0-3.665,14.191,17.52,17.52,0,0,0,6.495,11.073Z",
    transform: "translate(-214.34 -226.171)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M586.59,710.628a30.218,30.218,0,0,1-11.215-46.968,30.22,30.22,0,1,0,41.107,43.667,30.2,30.2,0,0,1-29.892,3.3Z",
    transform: "translate(-312.852 -327.744)",
    fill: "#3f3d56"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgot);
export default __webpack_public_path__ + "static/media/forgot.9547f8732c1f749885c72df88d7845ce.svg";
export { ForwardRef as ReactComponent };